import { isNil } from "lodash-es";
import ApiClientError from "./ApiClientError";

class ConflictError extends ApiClientError {
  static create: $TSFixMe;

  /* istanbul ignore next */
  constructor(request: $TSFixMe, response: $TSFixMe, cause: $TSFixMe) {
    super(
      "ConflictError",
      409,
      "Failed to create, update or delete a resource because of a conflict with an existing resource or due to existing assignments on the resource.",
      request,
      response,
      cause,
    );
    if (this.response && this.response.data) {
      this.errors = this.response.data.errors;
    }
  }

  contains = (type: $TSFixMe, attribute = null) => {
    if (attribute) {
      return (
        !isNil(this.errors) &&
        !isNil(
          this.errors.find(
            (error: $TSFixMe) =>
              error.type === type && error.attribute === attribute,
          ),
        )
      );
    }
    return (
      !isNil(this.errors) &&
      !isNil(this.errors.find((error: $TSFixMe) => error.type === type))
    );
  };
}

ConflictError.create = (errors: $TSFixMe) =>
  // @ts-expect-error TS(2554) FIXME: Expected 3 arguments, but got 2.
  new ConflictError(null, { data: { errors } });

export default ConflictError;
